import { useState } from "react";
import { Switch, Route } from "react-router-dom";
import { Login } from "../pages/Login";
import { Register } from "../pages/Register";
import { Dashboard } from "../pages/Dashboard";
import { Modal } from "../components/Modal";
import { Modal2 } from "../components/Modal2";

export const Routes = () => {
  const [user, setUser] = useState(null);
  const [login, setLogin] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const openModal = () => {
    setShowModal((res) => !res);
  };

  const openEditModal = () => {
    setShowEditModal((res) => !res);
  };

  return (
    <Switch>
      <Route exact path="/">
        <Login
          login={login}
          setLogin={setLogin}
          user={user}
          setUser={setUser}
        />
      </Route>

      <Route exact path="/register">
        <Register login={login} setLogin={setLogin} />
      </Route>

      <Route exact path="/dashboard/:id">
        <Dashboard
          onClick={() => openModal()}
          login={login}
          setLogin={setLogin}
          openModal={openModal}
          openEditModal={openEditModal}
        />
        <Modal showModal={showModal} setShowModal={setShowModal} />
        <Modal2
          showEditModal={showEditModal}
          setShowEditModal={setShowEditModal}
        />
      </Route>
    </Switch>
  );
};
